"use strict";
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/SearchViewModel.tsx"/>
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SearchBox = function (props) {
    var _a = react_1.useState({
        SearchTerm: '',
        RootFolder: '',
        Recursive: false,
        txtfnSearch: ''
    }), state = _a[0], setState = _a[1];
    var SearchItemsByText = function (e) {
        e.preventDefault();
        if (props.SearchTerm)
            props.SearchItems();
    };
    var handletxtChange = function (e) {
        props.onSerchChange(e.target.value);
    };
    return (react_1.default.createElement("div", { className: "card" },
        react_1.default.createElement("div", { className: "card-body row align-items-center" },
            react_1.default.createElement("div", { className: "col-12 col-md-7" },
                react_1.default.createElement("form", { action: "", method: "get", className: "help-centre-search", onSubmit: function (e) { return SearchItemsByText(e); } },
                    react_1.default.createElement("div", { className: "input-group mt-2 mb-2 input-group-lg" },
                        react_1.default.createElement("input", { name: "query", type: "text", className: "form-control", onChange: handletxtChange, placeholder: props.PlaceHolder, value: props.SearchTerm }),
                        react_1.default.createElement("div", { className: "input-group-append" },
                            react_1.default.createElement("button", { className: "btn btn-primary", type: "submit" },
                                react_1.default.createElement("i", { className: "fas fa-search" })))))),
            react_1.default.createElement("div", { className: "col-12 col-md-5 ml-auto text-right" }, props.children))));
};
exports.default = SearchBox;
